import React from 'react'; // Removed useEffect since it wasn't used

import {hooks} from '../hooks';
import {screens} from '../screens';
import {RootState} from '../store';

export const TabNavigator: React.FC = () => {
 const currentTabScreen = hooks.useAppSelector(
 (state: RootState) => state.tabSlice.screen,
 );

  // Keep these selectors if they are used by other components or tabs,
  // but they are now removed from the rendering logic below for simplicity.
 const cart = hooks.useAppSelector((state: RootState) => state.cartSlice.list);
const wishlist = hooks.useAppSelector(
 (state: RootState) => state.wishlistSlice.list,
 );

  // The rendering logic is now clean and only based on the currentTabScreen state.
  // The logic for empty/non-empty states (like cart/wishlist) should be handled 
  // INSIDE the Order and Wishlist screens themselves.
// Location: TabNavigator.tsx

// ...
const renderScreen = (): JSX.Element => {
    // NOTE: It is best practice to handle empty/full logic inside the
    // screens themselves (e.g., Wishlist.tsx should import and render WishlistEmpty)
    switch (currentTabScreen) {
      case 'Home':
        return <screens.Home />;
      case 'Search':
        return <screens.Categories />;
      case 'Order':
        // The Order screen should handle the cart.length check internally
        return <screens.Blog />;
     
      default:
        // Ensures Home is displayed if the tab state is empty or invalid
        return <screens.Home />; 
    }
};
// ...

 return renderScreen();
};